import {
  addDoc,
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  Timestamp,
  updateDoc,
} from 'firebase/firestore';
import { db } from '../firebase';

export interface PostSummary {
  id: string;
  title?: string;
  summary?: string;
  description?: string;
  schoolId?: string;
  status?: string;
  date?: Date;
  createdAt?: Date;
  updatedAt?: Date;
}

const COLLECTION = 'posts';

export async function listPostsSummary(): Promise<PostSummary[]> {
  const snap = await getDocs(
    query(collection(db, COLLECTION), orderBy('date', 'desc'))
  );

  return snap.docs.map((d) => {
    const data = d.data() as any;
    return {
      id: d.id,
      title: data.title,
      summary: typeof data.summary === 'string' ? data.summary : undefined,
      description: typeof data.description === 'string' ? data.description : undefined,
      schoolId: data.schoolId,
      status: data.status,
      date: data.date?.toDate ? data.date.toDate() : undefined,
      createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : undefined,
      updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : undefined,
    };
  });
}

export async function updatePostStatus(
  id: string,
  status: string
): Promise<void> {
  const ref = doc(db, COLLECTION, id);
  await updateDoc(ref, { status });
}

export async function updatePost(
  id: string,
  payload: {
    title: string;
    schoolId: string;
    status: string;
    date: Date;
    summary: string;
    description: string;
  }
): Promise<void> {
  const ref = doc(db, COLLECTION, id);
  await updateDoc(ref, {
    title: payload.title.trim(),
    schoolId: payload.schoolId.trim(),
    status: payload.status,
    date: Timestamp.fromDate(payload.date),
    summary: payload.summary.trim() || null,
    description: payload.description.trim() || null,
    updatedAt: new Date(),
  });
}

export async function createPost(payload: {
  title: string;
  schoolId: string;
  status: string;
  date: Date;
  summary: string;
  description: string;
}): Promise<string> {
  const ref = await addDoc(collection(db, COLLECTION), {
    title: payload.title.trim(),
    schoolId: payload.schoolId.trim(),
    status: payload.status,
    date: Timestamp.fromDate(payload.date),
    summary: payload.summary.trim() || null,
    description: payload.description.trim() || null,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return ref.id;
}

